<template>
  <q-card-actions align="center">
    <q-btn no-caps class="btn-brand" @click="onHistoricData"
      >Historic Data</q-btn
    >
    <q-btn no-caps class="btn-brand" @click="onQueueCommands">Commands</q-btn>
  </q-card-actions>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IDevice } from '@/models/Device';
import DeviceService from '@/services/DeviceService';

export default defineComponent({
  name: 'DeviceActions',
  computed: {
    device(): IDevice {
      return this.$store.state.device.selectedDevice;
    },
  },
  methods: {
    onHistoricData() {
      this.$store.dispatch('historicDataShow');
    },
    async onQueueCommands() {
      // Fetch the latest firmware info so the command dialog knows which commands to show.
      try {
        const response = await DeviceService.getLatestDeviceInfo(
          this.device.uid
        );
        if (response.data?.firmwareVersion != null) {
          this.device.firmwareVersion = parseFloat(
            response.data.firmwareVersion
          );
        }
      } catch {
        // Proceed with whatever firmware version the store already has.
      }

      if (this.device.isIridium) {
        this.$store.dispatch('queueCommandsIridiumShow');
      } else {
        this.$store.dispatch('queueCommandsShow');
      }
    },
  },
});
</script>

<style scoped></style>
